import type { PropsWithChildren } from "react";

import { type BaseCellProps, TextCell } from "@similarweb/pro-logic-components";

import type { PrimitiveListCellValue } from "../../types";
import { createPrimitiveListCellTooltipContent } from "../../utils";
import type { CellDefaultTooltipProps } from "../CellDefaultTooltip/CellDefaultTooltip";
import CellDefaultTooltip from "../CellDefaultTooltip/CellDefaultTooltip";

import { StyledTooltipContent } from "./styles";

type Props = PropsWithChildren<
    { value: readonly PrimitiveListCellValue[] } & Pick<BaseCellProps, "dataAutomation"> &
        Pick<CellDefaultTooltipProps, "tooltipPlacement">
>;

const ListCell = ({ value, dataAutomation, children, tooltipPlacement }: Props) => {
    const content = <TextCell dataAutomation={dataAutomation}>{children}</TextCell>;

    return !value || !value.length || value.length === 1 ? (
        content
    ) : (
        <CellDefaultTooltip
            tooltipPlacement={tooltipPlacement}
            content={<StyledTooltipContent>{createPrimitiveListCellTooltipContent(value)}</StyledTooltipContent>}
        >
            {content}
        </CellDefaultTooltip>
    );
};

export default ListCell;
